module.exports = __webpack_public_path__ + "static/mda_logo-11b9d033d574d6c726bcb27365229480.png";